import { configService } from '../services/config.service';

/**
 * Get the storage prefix for the current store
 * Returns the store subdomain or 'default' if not available
 */
export function getStoragePrefix(): string {
    try {
        const config = configService.getConfig();
        if (config?.store?.subdomain) {
            return `store_${config.store.subdomain}_`;
        }
        
        // Fallback: try to get from hostname or synced config
        const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
        
        // Local development with subdomain (e.g., caperoots.localhost)
        if (hostname.endsWith('.localhost')) {
            const subdomain = hostname.split('.')[0];
            return `store_${subdomain}_`;
        }
        
        // Plain localhost - try synced config
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            try {
                const syncedConfig = require('../../../.store-config.json');
                if (syncedConfig?.store?.subdomain) {
                    return `store_${syncedConfig.store.subdomain}_`;
                }
            } catch(error) {
                // .store-config.json doesn't exist
            }
        }
        
        // Production: parse from hostname (e.g., "mystore.cosmocart.shop" -> "mystore")
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            const subdomain = parts[0];
            if (subdomain && subdomain !== 'www') {
                return `store_${subdomain}_`;
            }
        }
    } catch (error) {
        console.warn('Failed to get storage prefix, using default:', error);
    }
    
    return 'store_default_';
}

/**
 * Create a prefixed storage name for Zustand persist
 */
export function getPrefixedStorageName(baseName: string): string {
    const prefix = getStoragePrefix();
    return `${prefix}${baseName}`;
}

